// import React, { useState } from 'react';
// import { ChevronLeft, ChevronRight, MapPin, Upload } from 'lucide-react';

// // --- Shared Components for the Application Flow ---

// // Generic Input Field
// const ApplicationInput = ({ label, value, onChange, placeholder, readOnly = false }) => (
//     <div>
//         <label className="block text-sm font-normal text-gray-700 mb-1">{label}</label>
//         <input
//             type="text"
//             value={value}
//             onChange={onChange}
//             readOnly={readOnly}
//             className={`w-full p-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 
//                 ${readOnly ? 'bg-gray-100 text-gray-500 font-medium border border-gray-200' : 'bg-white border border-gray-300 focus:border-blue-600'}
//             `}
//             placeholder={placeholder}
//         />
//     </div>
// );

// // Generic Select Field (Simulated using a div/button for UI match)
// const ApplicationSelect = ({ label, placeholder }) => (
//     <div>
//         <label className="block text-sm font-normal text-gray-700 mb-1">{label}</label>
//         <div className="w-full p-3 bg-white border border-gray-300 rounded-xl text-gray-500 flex justify-between items-center cursor-pointer hover:border-blue-500 transition">
//             <span className="text-sm">{placeholder}</span>
//             <ChevronRight className="w-5 h-5 text-gray-400 transform rotate-90" />
//         </div>
//     </div>
// );

// // --- Step 1: Application Details View (Matching New Meter Application Form.png) ---

// const ApplicationDetailsView = ({ onNext, onBack }) => {
//     // Mock state for form inputs
//     const [customerName, setCustomerName] = useState('Lucy'); 
    
//     // Hardcoded read-only mock data for UI match
//     const applicationId = 'ID: 39635';
//     const customerId = 'ID: 39635'; 

//     const handleContinue = () => {
//         // Simple validation check before continuing
//         if (customerName.trim() === '') {
//             console.error('Customer name cannot be empty');
//             return;
//         }
//         onNext();
//     };
    
//     return (
//         <div className="bg-gray-50 font-inter flex flex-col h-full w-full">
//             <div className="max-w-md mx-auto w-full bg-white shadow-xl relative flex-grow overflow-hidden">
                
//                 {/* Header: Matching Image UI */}
//                 <header className="flex w-full items-center p-4 border-b border-gray-200">
//                     <button 
//                         className="text-gray-600 hover:text-blue-500 transition" 
//                         onClick={onBack} 
//                         aria-label="Go back"
//                     >
//                         <ChevronLeft className="w-6 h-6" />
//                     </button>
//                     <h1 className="flex-grow text-center text-lg font-semibold text-gray-800 -ml-6">New Meter Application Form</h1>
//                 </header>
                
//                 <main className="h-full overflow-y-auto p-4 pt-6 pb-40"> {/* pb-40 for footer space */}
//                     <div className="space-y-6">
//                         {/* Application ID (Read-only) */}
//                         <ApplicationInput label="Application ID" value={applicationId} readOnly />

//                         {/* Customer ID (Read-only) */}
//                         <ApplicationInput label="CustomerID" value={customerId} readOnly />

//                         {/* Customer Name */}
//                         <ApplicationInput
//                             label="Customer Name"
//                             value={customerName}
//                             onChange={(e) => setCustomerName(e.target.value)}
//                             placeholder="Luc"
//                         />

//                         {/* Service Type (Dropdown Simulation) */}
//                         <ApplicationSelect label="Service Type" placeholder="Service Type" />

//                         {/* Connection Type (Dropdown Simulation) */}
//                         <ApplicationSelect label="Connection Type" placeholder="Connection Type" />

//                         {/* Expected Load (Input Simulation) */}
//                         <ApplicationSelect label="Expected Load" placeholder="Expected Load" />
                        
//                     </div>
//                 </main>

//                 {/* Footer Buttons: Matching Image UI */}
//                 <div className="absolute bottom-0 left-0 right-0 bg-white z-20 shadow-lg border-t border-gray-200 p-4">
//                     <button 
//                         onClick={onBack}
//                         className="w-full text-blue-600 py-3 rounded-xl font-semibold text-lg hover:bg-gray-50 transition duration-200 mb-3"
//                     >
//                         Cancel
//                     </button>
//                     <button 
//                         onClick={handleContinue}
//                         className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-700 transition duration-200"
//                     >
//                         Continue
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };


// // --- Step 2: Application Address View (Matching New Meter Application Form (1).jpg) ---

// const ApplicationAddressView = ({ onComplete, onBack }) => {
//     return (
//         <div className="bg-gray-50 font-inter flex flex-col h-full w-full">
//             <div className="max-w-md mx-auto w-full bg-white shadow-xl relative flex-grow overflow-hidden">
                
//                 {/* Header: Matching Image UI */}
//                 <header className="flex w-full items-center p-4 border-b border-gray-200">
//                     <button 
//                         className="text-gray-600 hover:text-blue-500 transition" 
//                         onClick={onBack} 
//                         aria-label="Go back"
//                     >
//                         <ChevronLeft className="w-6 h-6" />
//                     </button>
//                     <h1 className="flex-grow text-center text-lg font-semibold text-gray-800 -ml-6">New Meter Application Form</h1>
//                 </header>
                
//                 <main className="h-full overflow-y-auto p-4 pt-6 pb-40"> {/* pb-40 for footer space */}
//                     <h2 className="text-lg font-bold text-gray-900 mb-4">Address</h2>
                    
//                     {/* GPS Coordinates Section */}
//                     <div className="space-y-4 mb-8">
//                         <p className="text-sm font-normal text-gray-700">GPS coordinates</p>
//                         <p className="text-xs text-gray-500">Use your current location or drop a pin on the map.</p>
                        
//                         {/* Latitude, Longitude Input */}
//                         <input
//                             type="text"
//                             className="w-full p-3 bg-gray-100 rounded-xl border border-gray-300 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                             placeholder="Latitude, Longitude"
//                         />
                        
//                         {/* Use GPS Location Button */}
//                         <button
//                             className="w-full bg-blue-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow-lg bg-blue-600 hover:bg-blue-700 transition duration-200 flex items-center justify-center space-x-2"
//                             onClick={() => console.log('Using GPS Location')}
//                         >
//                             <MapPin className="w-5 h-5"/>
//                             <span>Use GPS Location</span>
//                         </button>
                        
//                         {/* Map Image (Simulation) */}
//                         <div className="w-full h-48 bg-gray-200 rounded-xl overflow-hidden relative border border-gray-300 flex items-center justify-center text-gray-500 text-sm italic">
//                             [Interactive Map Placeholder]
//                         </div>
//                     </div>

//                     {/* Property Image Section */}
//                     <h2 className="text-lg font-bold text-gray-900 mb-4">Property image</h2>
//                     <div className="space-y-4">
//                         {/* Add Property Image Placeholder */}
//                         <button className="w-full h-32 border-2 border-dashed border-gray-300 rounded-xl flex flex-col items-center justify-center text-gray-500 hover:border-blue-500 transition">
//                             <Upload className="w-8 h-8 mb-2" />
//                             <span className="text-sm font-medium">Add your property image</span>
//                         </button>

//                         {/* Set Manually Button (Dotted outline matching image) */}
//                         <button 
//                             className="w-full border-2 border-dashed border-gray-300 text-gray-600 py-3 rounded-xl font-semibold text-lg hover:bg-gray-50 transition duration-200"
//                             onClick={() => console.log('Setting address manually')}
//                         >
//                             Set manually
//                         </button>
//                     </div>
//                 </main>

//                 {/* Footer Buttons: Matching Image UI (Continue/Cancel logic) */}
//                 <div className="absolute bottom-0 left-0 right-0 bg-white z-20 shadow-lg border-t border-gray-200 p-4">
//                     <button 
//                         onClick={onBack} // User can cancel and go back to step 1 or home
//                         className="w-full text-blue-600 py-3 rounded-xl font-semibold text-lg hover:bg-gray-50 transition duration-200 mb-3"
//                     >
//                         Cancel
//                     </button>
//                     <button 
//                         onClick={onComplete} // Goes back to home/dashboard (simulating successful submission)
//                         className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-700 transition duration-200"
//                     >
//                         Submit Application
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// // --- Wrapper Component (Router) ---

// const NewMeterApplicationWrapper = ({ onBack, setActiveScreen }) => {
//     // State to manage the application steps: 'details' or 'address'
//     const [step, setStep] = useState('details'); 

//     // Mock handler for navigation
//     const handleNextStep = () => {
//         setStep('address');
//     };

//     const handlePreviousStep = () => {
//         if (step === 'address') {
//             setStep('details');
//         } else {
//             // If on 'details', go back to the main dashboard ('home')
//             onBack(); 
//         }
//     };

//     const handleSubmissionComplete = () => {
//         // In a real app, this would show a "Success" modal before going home.
//         console.log('Application Submitted!');
//         onBack(); // Go back to 'home' screen
//     }

//     let CurrentScreen;
//     if (step === 'details') {
//         CurrentScreen = <ApplicationDetailsView onNext={handleNextStep} onBack={handlePreviousStep} />;
//     } else { // step === 'address'
//         CurrentScreen = <ApplicationAddressView onComplete={handleSubmissionComplete} onBack={handlePreviousStep} />;
//     }

//     return (
//         <div className="min-h-screen">
//             {CurrentScreen}
//         </div>
//     );
// };

// export default NewMeterApplicationWrapper


// import React, { useState } from 'react';
// import { ChevronLeft, ChevronRight, MapPin, Upload } from 'lucide-react';

// // --- Shared Components for the Application Flow ---

// // Generic Input Field with conditional styling for the clean/read-only look vs. the editable box look.
// const ApplicationInput = ({ label, value, onChange, placeholder, readOnly = false, type = 'text', isSelect = false, isEditableBox = false }) => {
//     // isEditableBox is used to force the rounded pill style, even if the input is editable.
//     const isValueReadOnly = readOnly || !onChange;
    
//     // Style A: Clean, bottom-border look (Default for read-only and select simulations)
//     const isCleanLook = !isEditableBox && isValueReadOnly;

//     // Base input styling
//     const inputClasses = `
//         flex-grow text-gray-900 focus:outline-none focus:ring-2 w-full
//         ${isCleanLook 
//             ? 'bg-white font-normal border-b border-gray-200 border-t-0 border-l-0 border-r-0 rounded-none px-0 py-2' 
//             : 'bg-gray-50 border border-gray-300 rounded-xl px-3 py-3'
//         }
//         ${isCleanLook ? 'text-lg font-medium' : 'text-base font-normal'} 
//         ${!isCleanLook && !isValueReadOnly ? 'focus:border-blue-500 bg-white' : ''}
//         ${isValueReadOnly && isEditableBox ? 'bg-gray-100 border-none' : ''}
//     `;

//     // The wrapper ensures the chevron is positioned correctly for select/dropdown simulations
//     return (
//         <div>
//             {/* Label is always normal text */}
//             <label className="block text-sm font-normal text-gray-700 mb-1">{label}</label>
            
//             <div className={`w-full flex justify-between items-center ${isSelect ? 'cursor-pointer' : ''}`}>
//                 <input
//                     type={type}
//                     value={value}
//                     onChange={onChange}
//                     readOnly={isValueReadOnly}
//                     className={inputClasses}
//                     placeholder={placeholder}
//                 />
//                 {isSelect && <ChevronRight className="w-5 h-5 ml-2 text-gray-400" />}
//             </div>
//         </div>
//     );
// };

// // Generic Select Field (Uses the clean, bottom-border style)
// const ApplicationSelect = ({ label, placeholder }) => (
//     <ApplicationInput 
//         label={label} 
//         value={placeholder} 
//         readOnly={true} // True read-only input
//         isSelect={true} // Adds the chevron
//     />
// );


// // --- Step 1: Application Details View ---

// const ApplicationDetailsView = ({ onNext, onBack }) => {
//     // Mock state for form inputs
//     const [customerName, setCustomerName] = useState('Lucy'); 
    
//     // Hardcoded read-only mock data for UI match
//     const applicationId = 'ID: 39635';
//     const customerId = 'ID: 39635'; 

//     const handleContinue = () => {
//         if (customerName.trim() === '') {
//             console.error('Customer name cannot be empty');
//             return;
//         }
//         onNext();
//     };
    
//     return (
//         <div className="bg-gray-50 font-inter flex flex-col h-full w-full">
//             <div className="max-w-md mx-auto w-full bg-white shadow-xl relative flex-grow overflow-hidden">
                
//                 {/* Header: Matching Image UI, including the blue tab indicator */}
//                 <header className="flex w-full items-center p-4 border-b border-gray-200">
//                     <button 
//                         className="text-gray-600 hover:text-blue-500 transition" 
//                         onClick={onBack} 
//                         aria-label="Go back"
//                     >
//                         <ChevronLeft className="w-6 h-6" />
//                     </button>
//                     <div className="flex-grow text-center relative">
//                         <h1 className="text-lg font-semibold text-gray-800">New Meter Application Form</h1>
//                         {/* Blue indicator line for the current step */}
//                         <div className="absolute bottom-[-17px] left-1/4 h-1 w-1/2 bg-blue-600 rounded-t-lg"></div>
//                     </div>
//                 </header>
                
//                 <main className="h-full overflow-y-auto p-4 pt-6 pb-40"> 
//                     <div className="space-y-6">
//                         {/* Application ID (Read-only - uses clean bottom-border look) */}
//                         <ApplicationInput label="Application ID" value={applicationId} readOnly />

//                         {/* Customer ID (Read-only - uses clean bottom-border look) */}
//                         <ApplicationInput label="CustomerID" value={customerId} readOnly />

//                         {/* Customer Name (Editable - uses the rounded editable box look) */}
//                         <ApplicationInput
//                             label="Customer Name"
//                             value={customerName}
//                             onChange={(e) => setCustomerName(e.target.value)}
//                             placeholder="Luc"
//                             isEditableBox={true} // Force the pill/box style
//                         />

//                         {/* Service Type (Dropdown Simulation - uses clean bottom-border look) */}
//                         <ApplicationSelect label="Service Type" placeholder="Service Type" />

//                         {/* Connection Type (Dropdown Simulation - uses clean bottom-border look) */}
//                         <ApplicationSelect label="Connection Type" placeholder="Connection Type" />

//                         {/* Expected Load (Input Simulation - uses clean bottom-border look) */}
//                         <ApplicationSelect label="Expected Load" placeholder="Expected Load" />
                        
//                     </div>
//                 </main>

//                 {/* Footer Buttons: Matching Image UI */}
//                 <div className="absolute bottom-0 left-0 right-0 bg-white z-20 shadow-lg border-t border-gray-200 p-4">
//                     <button 
//                         onClick={onBack}
//                         className="w-full text-blue-600 py-3 rounded-xl font-semibold text-lg hover:bg-gray-50 transition duration-200 mb-3"
//                     >
//                         Cancel
//                     </button>
//                     <button 
//                         onClick={handleContinue}
//                         className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-700 transition duration-200"
//                     >
//                         Continue
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };


// // --- Step 2: Application Address View ---

// const ApplicationAddressView = ({ onComplete, onBack }) => {
//     const [manualInput, setManualInput] = useState(false);
    
//     // Mock state for manual inputs (Note: using hardcoded values to match the screenshot)
//     const [street] = useState('775 Rolling Green Rd.');
//     const [city] = useState('Pembroke Pines');
//     const [lga] = useState('name@email.com'); // Mocked LGA/Email input
//     const [state] = useState('Mexico City');
//     const [disco] = useState('Mexico City');
//     const [sbc] = useState('Mexico City');

//     return (
//         <div className="bg-gray-50 font-inter flex flex-col h-full w-full">
//             <div className="max-w-md mx-auto w-full bg-white shadow-xl relative flex-grow overflow-hidden">
                
//                 {/* Header: Matching Image UI, including the blue tab indicator */}
//                 <header className="flex w-full items-center p-4 border-b border-gray-200">
//                     <button 
//                         className="text-gray-600 hover:text-blue-500 transition" 
//                         onClick={onBack} 
//                         aria-label="Go back"
//                     >
//                         <ChevronLeft className="w-6 h-6" />
//                     </button>
//                     <div className="flex-grow text-center relative">
//                         <h1 className="text-lg font-semibold text-gray-800">New Meter Application Form</h1>
//                         {/* Blue indicator line for the current step */}
//                         <div className="absolute bottom-[-17px] left-1/4 h-1 w-1/2 bg-blue-600 rounded-t-lg"></div>
//                     </div>
//                 </header>
                
//                 <main className="h-full overflow-y-auto p-4 pt-6 pb-40"> 
                    
//                     {/* 1. Map/GPS/Property Image Section (Shown when manualInput is FALSE) */}
//                     {!manualInput ? (
//                         <>
//                             <h2 className="text-lg font-bold text-gray-900 mb-4">Address</h2>
//                             <div className="space-y-4 mb-8">
//                                 <p className="text-sm font-normal text-gray-700">GPS coordinates</p>
//                                 <p className="text-xs text-gray-500">Use your current location or drop a pin on the map.</p>
                                
//                                 {/* Latitude, Longitude Input (Uses the pill/box editable style) */}
//                                 <ApplicationInput 
//                                     label="" // Label is handled by the placeholder here
//                                     value="" 
//                                     placeholder="Latitude, Longitude"
//                                     readOnly={true} // Simulating a read-only input that gets value from map/GPS
//                                     isEditableBox={true} // Force the pill/box style
//                                 />

//                                 {/* Use GPS Location Button */}
//                                 <button
//                                     className="w-full text-white py-3 rounded-xl font-semibold text-lg shadow-lg bg-blue-600 hover:bg-blue-700 transition duration-200 flex items-center justify-center space-x-2"
//                                     onClick={() => console.log('Using GPS Location')}
//                                 >
//                                     <MapPin className="w-5 h-5"/>
//                                     <span>Use GPS Location</span>
//                                 </button>
                                
//                                 {/* Map Image (Simulation) */}
//                                 <div className="w-full h-48 bg-gray-200 rounded-xl overflow-hidden relative border border-gray-300 flex items-center justify-center text-gray-500 text-sm italic">
//                                     [Interactive Map Placeholder]
//                                 </div>
//                             </div>
                            
//                             {/* Property Image Section when not manual */}
//                             <h2 className="text-lg font-bold text-gray-900 mb-4">Property image</h2>
//                             <button className="w-full h-32 border-2 border-dashed border-gray-300 rounded-xl flex flex-col items-center justify-center text-gray-500 hover:border-blue-500 transition mb-4">
//                                 <Upload className="w-8 h-8 mb-2" />
//                                 <span className="text-sm font-medium">Add your property image</span>
//                             </button>
//                         </>
//                     ) : (
//                         // When manual input is active, we only show the address header once
//                         <h2 className="text-lg font-bold text-gray-900 mb-6">Address</h2>
//                     )}

//                     {/* 2. Set Manually Button (Toggles visibility of the manual address section) */}
//                     <button 
//                         className={`w-full text-gray-600 py-3 font-semibold text-lg border-2 border-dashed border-gray-300 rounded-xl hover:bg-gray-50 transition duration-200`}
//                         onClick={() => setManualInput(!manualInput)} 
//                     >
//                         {manualInput ? 'Use GPS' : 'Set manually'}
//                     </button>
                    
//                     {/* 3. Manual Address Input Fields (Appears IMMEDIATELY below the button when active, using the clean bottom-border look) */}
//                     {manualInput && (
//                         <div className="space-y-6 mt-8">
//                             <ApplicationInput label="Street" value={street} readOnly={true} />
//                             <ApplicationSelect label="City" placeholder={city} /> 
//                             <ApplicationInput label="LGA" value={lga} readOnly={true} /> 
//                             <ApplicationSelect label="State" placeholder={state} />
//                             <ApplicationSelect label="Preferred DISCO" placeholder={disco} />
//                             <ApplicationSelect label="Preferred SBC (optional)" placeholder={sbc} />
//                         </div>
//                     )}
//                 </main>

//                 {/* Footer Buttons: Conditional Button Text */}
//                 <div className="absolute bottom-0 left-0 right-0 bg-white z-20 shadow-lg border-t border-gray-200 p-4">
//                     <button 
//                         onClick={onBack} 
//                         className="w-full text-blue-600 py-3 rounded-xl font-semibold text-lg hover:bg-gray-50 transition duration-200 mb-3"
//                     >
//                         Cancel
//                     </button>
//                     <button 
//                         onClick={onComplete} 
//                         className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-700 transition duration-200"
//                     >
//                         {manualInput ? 'Update' : 'Submit Application'}
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// // --- Wrapper Component (Router - Unchanged) ---

// const NewMeterApplicationWrapper = ({ onBack, setActiveScreen }) => {
//     const [step, setStep] = useState('details'); 

//     const handleNextStep = () => {
//         setStep('address');
//     };

//     const handlePreviousStep = () => {
//         if (step === 'address') {
//             setStep('details');
//         } else {
//             onBack(); 
//         }
//     };

//     const handleSubmissionComplete = () => {
//         console.log('Application Submitted!');
//         onBack();
//     }

//     let CurrentScreen;
//     if (step === 'details') {
//         CurrentScreen = <ApplicationDetailsView onNext={handleNextStep} onBack={handlePreviousStep} />;
//     } else { // step === 'address'
//         CurrentScreen = <ApplicationAddressView onComplete={handleSubmissionComplete} onBack={handlePreviousStep} />;
//     }

//     return (
//         <div className="min-h-screen">
//             {CurrentScreen}
//         </div>
//     );
// };

// export default NewMeterApplicationWrapper

import React, { useState, useRef, useEffect } from 'react';
import { ChevronLeft, ChevronRight,Check, MapPin, Upload, ChevronDown, ChevronRight as ArrowRight, Folder, Pause, X } from 'lucide-react';

// --- Shared Components for the Application Flow ---

/**
 * Renders a highly customizable input field based on the design context.
 * This serves as the visual wrapper for both editable inputs and dropdown triggers.
 * * Props:
 * - label: string
 * - value: string
 * - onClick: function (for select/readOnly fields)
 * - onChange: function (optional)
 * - placeholder: string
 * - readOnly: bool
 * - isSelect: bool (renders ChevronDown and applies selection styles)
 * - variant: 'solidId' | 'pill'
 */
const ApplicationInput = ({
    label,
    value = '',
    onClick,
    onChange,
    placeholder = '',
    readOnly = false,
    isSelect = false,
    variant = 'pill',
    type = 'text',
    multiline = false,
    rows = 4
}) => {
    // Only editable if an onChange function is provided AND it's not explicitly readOnly
    const isEditable = typeof onChange === 'function' && !readOnly;
    // Clickable if it's a dropdown trigger or an editable field
    const isClickable = isSelect || isEditable;

    // Shared size & radius
    const heightClass = multiline ? '' : 'h-12'; // 48px
    const radiusClass = 'rounded-xl'; // Consistent with the pill look

    // Variant-specific appearance
    const baseBg = variant === 'solidId' ? 'bg-blue-50' : 'bg-[#F4F7FF]';
    const textGray = readOnly ? 'text-gray-600' : 'text-gray-900';
    const placeholderClass = 'placeholder-gray-400';
    
    // Default focus/border for editable inputs (blue)
    const editableFocusStyle = isEditable ? 'focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-blue-500' : '';

    // Custom click/focus style for select fields (black ring/border as requested)
    const selectClickStyle = isSelect ? 'cursor-pointer focus:border-gray-500 focus:ring-1 focus:ring-gray-900' : '';
    
    // Apply styling based on interactivity
    const interactionStyles = isEditable ? editableFocusStyle : selectClickStyle;
    
    // Input wrapper classes
    const inputClasses = `
        ${heightClass} ${radiusClass} w-full px-4 py-2
        ${baseBg} ${textGray} ${placeholderClass}
        border border-transparent
        ${interactionStyles}
        transition-all duration-150
        ${isClickable ? 'cursor-pointer' : 'cursor-default'}
        appearance-none
        ${multiline ? 'resize-none' : ''}
    `;

    return (
        <div className="w-full">
            {label ? <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label> : null}
            <div className="relative">
                {multiline ? (
                    <textarea
                        value={value}
                        onChange={onChange}
                        placeholder={placeholder}
                        readOnly={!isEditable}
                        aria-readonly={!isEditable}
                        className={inputClasses}
                        rows={rows}
                    />
                ) : (
                    <input
                        type={type}
                        value={value}
                        onClick={isClickable ? onClick : null} // Handle click for select and editable fields
                        onChange={onChange}
                        placeholder={placeholder}
                        readOnly={!isEditable || isSelect} // ReadOnly unless explicitly editable
                        aria-readonly={!isEditable || isSelect}
                        className={inputClasses}
                    />
                )}
                
                {isSelect && (
                    // ChevronDown for standard dropdown indicator
                    <ChevronDown className="w-5 h-5 text-gray-400 absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none" />
                )}
            </div>
        </div>
    );
};

// --- New Dropdown Component ---

const Dropdown = ({ label, placeholder, options, value, onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleInputClick = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (option) => {
        onSelect(option);
        setIsOpen(false);
    };

    // Determine the current display value
    const displayValue = value || placeholder;

    return (
        <div className="relative w-full" ref={wrapperRef}>
            {/* Input Trigger (uses ApplicationInput with the black highlight style) */}
            <ApplicationInput
                label={label}
                value={displayValue}
                readOnly
                isSelect
                onClick={handleInputClick}
                variant="pill"
            />

            {/* Options List */}
            {isOpen && (
                <div className="absolute z-20 w-full mt-1 bg-white border border-gray-300 rounded-xl shadow-xl max-h-60 overflow-y-auto animate-fadeIn">
                    {options.map((option, index) => (
                        <div
                            key={index}
                            onClick={() => handleOptionClick(option)}
                            className={`p-3 text-sm cursor-pointer hover:bg-blue-50 transition ${option === value ? 'bg-blue-100 font-semibold text-blue-800' : 'text-gray-700'}`}
                        >
                            {option}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};


// --- Step 1: Application Details View ---

// Dummy options for the select fields
const serviceTypeOptions = ['Residential', 'Commercial', 'Industrial'];
const connectionTypeOptions = ['Single Phase', 'Three Phase'];
const expectedLoadOptions = ['< 10 KVA', '10 - 50 KVA', '> 50 KVA'];

const ApplicationDetailsView = ({ onNext, onBack }) => {
    const [customerName, setCustomerName] = useState('Lucy');
    const [serviceType, setServiceType] = useState(serviceTypeOptions[0]);
    const [connectionType, setConnectionType] = useState(connectionTypeOptions[0]);
    const [expectedLoad, setExpectedLoad] = useState(expectedLoadOptions[0]);

    const applicationId = 'ID: 39635';
    const customerId = 'ID: 39635';

    const handleContinue = () => {
        if (!customerName.trim()) {
            console.warn('Customer name cannot be empty');
            return;
        }
        onNext();
    };
    
    const stepProgress = 1 / 3;

    return (

//  <div className="bg-white font-inter flex flex-col h-screen w-full">
//             {/* <div className="max-w-md mx-auto w-full bg-white shadow-xl relative flex-grow overflow-hidden"> */}
//             <Header title="Checkout" onBack={onBack} />

//             {/* Wrap main content in a form element */}
//             <form onSubmit={handleContinueToPayment} className="h-full flex flex-col">

//                 <main className="flex-grow overflow-y-auto p-4 pt-6 pb-24"></main>
        
        <div className="bg-white font-inter flex flex-col h-screen w-full">
        <header className="flex items-center p-4 border-b border-gray-200 relative">
            <button
                onClick={onBack}
                aria-label="Go back"
                className="text-gray-600 hover:text-blue-600 transition mr-2"
            >
                <ChevronLeft className="w-6 h-6" />
            </button>

            <div className="flex-1 text-center relative">
                <h1 className="text-lg font-semibold text-gray-800">New Meter Application Form</h1>
            </div>
            {/* Blue indicator line for the current step (1/3) */}
            <div className="absolute bottom-0 left-0 right-0 h-1">
                <div 
                    className="h-full bg-blue-600 mx-auto rounded-t-lg transition-all duration-300" 
                    style={{ width: `${stepProgress * 100}%` }}
                ></div>
            </div>
        </header>

        {/* Content - Increased padding to pb-48 to avoid last field being covered by the footer */}
        <main className="flex-grow overflow-y-auto p-8 pt-6">
            <div className="space-y-6">
                {/* Application ID: Solid/Darker fill (variant="solidId") */}
                {/* <ApplicationInput label="Application ID" value={applicationId} readOnly variant="solidId" /> */}

                {/* Customer ID: Solid/Darker fill (variant="solidId") */}
                {/* <ApplicationInput label="CustomerID" value={customerId} readOnly variant="solidId" /> */}

                {/* Customer Name (editable pill) */}
                <ApplicationInput
                    label="Customer Name"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    placeholder="Lucy"
                    variant="pill"
                />

                {/* Dropdown fields with options */}
                <Dropdown 
                    label="Service Type" 
                    placeholder="Select Service Type"
                    options={serviceTypeOptions}
                    value={serviceType}
                    onSelect={setServiceType}
                />
                <Dropdown 
                    label="Meter Type" 
                    placeholder="Select Connection Type"
                    options={connectionTypeOptions}
                    value={connectionType}
                    onSelect={setConnectionType}
                />
                <Dropdown 
                    label="Expected Load" 
                    placeholder="Select Expected Load"
                    options={expectedLoadOptions}
                    value={expectedLoad}
                    onSelect={setExpectedLoad}
                />
            </div>
        </main>

        {/* Footer actions */}
        {/* <div className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4"> */}
             {/* <div className="bg-white border-t border-gray-200 p-4"> */}
             <div className="sticky bottom-0 bg-white border-t p-4">

            <button
                onClick={onBack}
                className="w-full text-blue-600 py-3 rounded-xl font-semibold text-lg hover:bg-gray-50 transition mb-3"
            >
                Cancel
            </button>
            <button
                onClick={handleContinue}
                className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow hover:bg-blue-700 transition"
            >
                Continue
            </button>
        </div>
        </div>
    );
};

// --- Step 2: Application Address View ---

// Dummy options for the select fields
const cityOptions = ['Lagos', 'Abuja', 'Kano', 'Ibadan', 'Port Harcourt', 'Kaduna'];
const stateOptions = ['Lagos State', 'Oyo State', 'Kano State', 'FCT Abuja', 'Rivers State', 'Kaduna State'];
const discoOptions = ['Eko Disco', 'Ibadan Disco', 'Abuja Disco', 'P-Harcourt Disco'];
const sbcOptions = ['SBC Alpha', 'SBC Beta', 'SBC Gamma', 'SBC Delta', 'None'];


const ApplicationAddressView = ({ onComplete, onBack }) => {
    const [manualInput, setManualInput] = useState(false);

    // Mock values
    const [latLong] = useState('-6.524, 3.425');
    const [street] = useState('775 Rolling Green Rd.');
    const [lga] = useState('LGA Placeholder');
    
    const [selectedCity, setSelectedCity] = useState(cityOptions[0]);
    const [selectedState, setSelectedState] = useState(stateOptions[0]);
    const [selectedDisco, setSelectedDisco] = useState(discoOptions[0]);
    const [selectedSBC, setSelectedSBC] = useState(sbcOptions[4]);

    const handleContinue = () => {
        // In a real app, validate address here
        onComplete();
    };
    
    const stepProgress = 2 / 3;

    return (
        <div>
        <header className="flex items-center p-4 border-b border-gray-200 relative">
            <button
                onClick={onBack}
                aria-label="Go back"
                className="text-gray-600 hover:text-blue-600 transition mr-2"
            >
                <ChevronLeft className="w-6 h-6" />
            </button>

            <div className="flex-1 text-center relative">
                <h1 className="text-lg font-semibold text-gray-800">New Meter Application Form</h1>
            </div>
            {/* Blue indicator line for the current step (2/3) */}
            <div className="absolute bottom-0 left-0 right-0 h-1">
                <div 
                    className="h-full bg-blue-600 mx-auto rounded-t-lg transition-all duration-300" 
                    style={{ width: `${stepProgress * 100}%` }}
                ></div> 
            </div>
        </header>

        <main className="p-6 pb-48 overflow-y-auto">
            {!manualInput ? (
                <>
                    <h2 className="text-lg font-bold text-gray-900 mb-3">Address</h2>

                    <div className="space-y-4 mb-6">
                        <p className="text-sm text-gray-700">GPS coordinates</p>
                        <p className="text-xs text-gray-500 mb-2">Use your current location or drop a pin on the map.</p>

                        {/* Latitude, Longitude Input (Editable pill look) */}
                        <ApplicationInput
                            label=""
                            value={latLong}
                            placeholder="Latitude, Longitude"
                            variant="pill"
                            readOnly
                            onClick={() => console.log('Opens map picker')}
                        />

                        <button
                            onClick={() => console.log('Using GPS Location')}
                            className="w-full h-12 rounded-xl flex items-center justify-center space-x-2 bg-blue-600 text-white font-semibold hover:bg-blue-700 transition"
                            aria-label="Use GPS location"
                        >
                            <MapPin className="w-5 h-5" />
                            <span>Use GPS Location</span>
                        </button>

                        <div className="w-full h-48 rounded-xl overflow-hidden border border-gray-300 flex items-center justify-center bg-gray-100 text-gray-500">
                            <div className="text-sm italic">[Interactive Map Placeholder]</div>
                        </div>
                    </div>

                    <h3 className="text-lg font-bold text-gray-900 mb-3">Property image</h3>

                    <button
                        className="w-full h-32 border-2 border-dashed border-gray-300 rounded-xl flex flex-col items-center justify-center text-gray-500 hover:border-blue-500 transition mb-4"
                        aria-label="Add property image"
                    >
                        <Upload className="w-8 h-8 mb-2" />
                        <span className="text-sm font-medium">Add your property image</span>
                    </button>
                </>
            ) : (
                <h2 className="text-lg font-bold text-gray-900 mb-6">Address Details</h2>
            )}

            <button
                onClick={() => setManualInput((s) => !s)}
                className="w-full py-3 rounded-xl border-2 border-dashed border-gray-300 text-gray-700 font-semibold hover:bg-gray-50 transition"
            >
                {manualInput ? 'Use GPS' : 'Set manually'}
            </button>

            {manualInput && (
                <div className="space-y-6 mt-6">
                    {/* Manual Address Fields */}
                    <ApplicationInput label="Street" value={street} onChange={() => {}} placeholder="Enter street address" variant="pill" />
                    <Dropdown label="City" placeholder="Select City" options={cityOptions} value={selectedCity} onSelect={setSelectedCity} />
                    <ApplicationInput label="LGA" value={lga} onChange={() => {}} placeholder="Enter LGA" variant="pill" />
                    <Dropdown label="State" placeholder="Select State" options={stateOptions} value={selectedState} onSelect={setSelectedState} />
                    <Dropdown label="Preferred DISCO" placeholder="Select DISCO" options={discoOptions} value={selectedDisco} onSelect={setSelectedDisco} />
                    <Dropdown label="Preferred SBC (optional)" placeholder="Select SBC" options={sbcOptions} value={selectedSBC} onSelect={setSelectedSBC} />
                </div>
            )}
        </main>

        <div className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4">
            <button
                onClick={onBack}
                className="w-full text-blue-600 py-3 rounded-xl font-semibold text-lg hover:bg-gray-50 transition mb-3"
            >
                Cancel
            </button>
            <button
                onClick={handleContinue}
                className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow hover:bg-blue-700 transition"
            >
                Continue
            </button>
        </div>
        </div>
    );
};

// --- Document Upload Panel Component (New) ---

const DocumentUploadPanel = ({ docKey, isUploaded }) => {
    // Mock upload progress state
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (uploading) {
            // Simulate upload progress
            const interval = setInterval(() => {
                setProgress(prev => {
                    if (prev >= 65) { // Stop at 65% for the visual mock
                        clearInterval(interval);
                        return 65;
                    }
                    return prev + 5;
                });
            }, 500);
            return () => clearInterval(interval);
        } else {
            setProgress(0);
        }
    }, [uploading]);

    const handleBrowseClick = () => {
        // Simulate starting the upload
        setUploading(true);
        console.log(`Starting upload for: ${docKey}`);
    };

    const handleCancelClick = () => {
        // Simulate cancelling the upload
        setUploading(false);
        setProgress(0);
        console.log(`Cancelled upload for: ${docKey}`);
    };

    if (isUploaded) {
        // If already uploaded, maybe show a success state or review file
        return (
            <div className="p-4 bg-green-50 border border-green-300 rounded-xl mt-3 text-sm text-green-800 flex items-center justify-between">
                <span>File uploaded successfully!</span>
                <X className="w-4 h-4 cursor-pointer" onClick={handleCancelClick} />
            </div>
        );
    }

    return (
        <div className="mt-3">
            {/* Upload Area */}
            <div className={`p-8 border-2 border-dashed ${uploading ? 'border-blue-500' : 'border-gray-300'} rounded-xl flex flex-col items-center justify-center bg-white transition`}>
                <Folder className="w-12 h-12 text-blue-600 mb-3" />
                <p className="text-gray-500 mb-4">Drag your file(s) to start uploading</p>
                <button
                    onClick={handleBrowseClick}
                    className="px-4 py-2 text-sm text-blue-600 border border-blue-600 rounded-xl font-semibold hover:bg-blue-50 transition"
                >
                    Browse files
                </button>
            </div>

            {/* Uploading Status Bar (Mocked to stop at 65%) */}
            {uploading && (
                <div className="mt-4 bg-white p-4 rounded-xl shadow">
                    <p className="text-sm font-semibold text-gray-800 mb-2">
                        Uploading...
                    </p>
                    <div className="flex items-center space-x-3">
                        {/* Progress Bar Container */}
                        <div className="flex-1 bg-gray-200 rounded-full h-2.5">
                            <div 
                                className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
                                style={{ width: `${progress}%` }}
                            ></div>
                        </div>
                        {/* Progress Details */}
                        <div className="flex items-center text-xs text-gray-500 space-x-2">
                            <span>{progress}%</span>
                            <span className="text-gray-400">•</span>
                            <span>{65 - progress}% remaining</span> {/* Mock calculation */}
                        </div>

                        {/* Control Buttons */}
                        <button onClick={handleCancelClick} aria-label="Pause upload" className="text-gray-500 hover:text-gray-900">
                            <Pause className="w-5 h-5" />
                        </button>
                        <button onClick={handleCancelClick} aria-label="Cancel upload" className="text-red-500 hover:text-red-700">
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};


// --- Step 3 Components ---

const DocumentUploadItem = ({ label, isUploaded = false, isActive = false, onClick, children }) => {
    // Determine the icon and color based on upload status
    const iconClass = isUploaded ? 'bg-blue-600' : 'bg-white';
    const borderClass = isUploaded ? 'border-blue-600' : 'border-gray-400';
    
    // Determine the background color for the overall item if it's active
    const itemBgClass = isActive ? 'bg-blue-50' : 'hover:bg-gray-50';

    return (
        <div className={`transition-all duration-300 rounded-xl ${itemBgClass}`}>
            {/* Clickable Header Row */}
            <div
                className="flex items-center justify-between py-4 px-3 cursor-pointer"
                onClick={onClick}
            >
                {/* Radio-like circle and label */}
                <div className="flex items-center space-x-3">
                    <div className={`w-5 h-5 rounded-full border-2 p-0.5 flex items-center justify-center ${borderClass}`}>
                        <div className={`w-full h-full rounded-full ${iconClass} transition-colors duration-200`} />
                    </div>
                    <span className={`font-medium ${isActive ? 'text-blue-800' : 'text-gray-700'}`}>{label}</span>
                </div>
                {/* Right Arrow/Chevron */}
                <ArrowRight className={`w-5 h-5 transition-transform duration-300 ${isActive ? 'text-blue-600 transform rotate-90' : 'text-gray-400'}`} />
            </div>

            {/* Expanded Content Area (Upload Panel) */}
            {isActive && (
                <div className="pb-4 px-3">
                    {children}
                </div>
            )}
        </div>
    );
};

const ApplicationDocumentsView = ({ onComplete, onBack }) => {
    // Mock state for document status (true = uploaded, false = not uploaded)
  // Mock state for document status (true = uploaded, false = not uploaded)
    const [documents, setDocuments] = useState({
        idCard: false,
        proofOfOwnership: false,
        sitePhoto: false,
    });
    // State to track which document item is currently expanded
    const [activeDocument, setActiveDocument] = useState(null); // 'idCard' | 'proofOfOwnership' | 'sitePhoto' | null
    const [notes, setNotes] = useState('');

    const handleItemClick = (docKey) => {
        // If clicking the currently active item, close it. Otherwise, open the new one.
        setActiveDocument(prev => (prev === docKey ? null : docKey));
        
        // Mock: If we open an item, simulate that its upload is successful after a delay
        if (activeDocument !== docKey) {
             // In a real application, you would handle the actual upload here.
             // For this mock, we automatically mark it as uploaded after 5 seconds
             setTimeout(() => {
                setDocuments(prev => ({
                    ...prev,
                    [docKey]: true
                }));
             }, 5000); 
        }
    };

    const handleSubmit = () => {
        // Check if all mandatory documents are uploaded
        const allUploaded = Object.values(documents).every(status => status === true);
        if (!allUploaded) {
            console.warn("Please upload all required documents before submitting.");
            // Replace alert() with a console warning or custom modal as per instructions
            // Note: Since this is a critical check, I'm logging it but allowing submission in the mock for flow demo
            // In a real app, this would block navigation.
            // For the demo, we will allow submission to proceed to the success screen:
            onComplete();
            return;
        }
        onComplete();
    };

    const stepProgress = 3 / 3;

    return (
        <div>
            <header className="flex items-center p-4 border-b border-gray-200 relative">
                <button
                    onClick={onBack}
                    aria-label="Go back"
                    className="text-gray-600 hover:text-blue-600 transition mr-2"
                >
                    <ChevronLeft className="w-6 h-6" />
                </button>

                <div className="flex-1 text-center relative">
                    <h1 className="text-lg font-semibold text-gray-800">New Meter Application Form</h1>
                </div>
                {/* Blue indicator line for the current step (3/3) - Full width */}
                <div className="absolute bottom-0 left-0 right-0 h-1">
                    <div 
                        className="h-full bg-blue-600 mx-auto rounded-t-lg transition-all duration-300" 
                        style={{ width: `${stepProgress * 100}%` }}
                    ></div> 
                </div>
            </header>

            <main className="p-6 pb-24 overflow-y-auto space-y-6">
                
                {/* Documents Upload Card */}
                <div className="">
                    <h2 className="text-lg font-bold text-gray-900 mb-2">Documents upload</h2>
                    <p className="text-sm text-gray-500 mb-4">
                        Please upload the necessary documents for verification and processing.
                    </p>

                    <div className="space-y-1 divide-y divide-gray-100 divide-x-0">
                        <DocumentUploadItem 
                            label="ID Card" 
                            docKey="idCard"
                            isUploaded={documents.idCard}
                            isActive={activeDocument === 'idCard'}
                            onClick={() => handleItemClick('idCard')}
                        >
                            <DocumentUploadPanel docKey="idCard" isUploaded={documents.idCard} />
                        </DocumentUploadItem>
                        
                        <DocumentUploadItem 
                            label="Proof of ownership" 
                            docKey="proofOfOwnership"
                            isUploaded={documents.proofOfOwnership}
                            isActive={activeDocument === 'proofOfOwnership'}
                            onClick={() => handleItemClick('proofOfOwnership')}
                        >
                            <DocumentUploadPanel docKey="proofOfOwnership" isUploaded={documents.proofOfOwnership} />
                        </DocumentUploadItem>
                        
                        <DocumentUploadItem 
                            label="Site photo" 
                            docKey="sitePhoto"
                            isUploaded={documents.sitePhoto}
                            isActive={activeDocument === 'sitePhoto'}
                            onClick={() => handleItemClick('sitePhoto')}
                        >
                            <DocumentUploadPanel docKey="sitePhoto" isUploaded={documents.sitePhoto} />
                        </DocumentUploadItem>
                    </div>
                </div>

                {/* Additional Notes Card */}
                <div className="">
                    <h2 className="text-lg font-bold text-gray-900 mb-2">Additional notes</h2>
                    <p className="text-sm text-gray-500 mb-4">
                        Add any extra information relevant to your application or installation site.
                    </p>
                    <ApplicationInput
                        label="Notes"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        placeholder="e.g., Preferred installation time, access details..."
                        multiline
                        rows={6}
                        variant="pill"
                    />
                </div>

                {/* This button replicates the "Save Draft" visual from the image but is placed
                    in the scrollable content area, NOT the fixed footer */}
                <button
                    onClick={() => console.log('Draft saved')}
                    className="w-full text-blue-600 py-3 rounded-xl font-semibold text-lg hover:bg-gray-50 transition"
                >
                    Save Draft
                </button>
            </main>

            {/* Fixed Footer actions - Primary Action (Submit) */}
            <div className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4">
                <button
                    onClick={handleSubmit}
                    className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow hover:bg-blue-700 transition"
                >
                    Submit Application
                </button>
            </div>
        </div>
    );
};


// --- Step 4: Success View (New Component) ---
const ApplicationSuccessView = ({ onDone }) => {
    return (
        <div className="flex flex-col items-center justify-center h-full p-8 text-center bg-white pt-36">
            
            {/* Animated Checkmark and Confetti Mock */}
            <div className="relative mb-8">
                {/* Confetti (Small dots flying out, mocked with CSS classes) */}
                <div className="absolute inset-0 flex items-center justify-center">
                    {/* Mock confetti particles */}
                    {[...Array(20)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute w-1 h-1 bg-blue-400 rounded-full"
                            style={{
                                top: `${Math.random() * 100}%`,
                                left: `${Math.random() * 100}%`,
                                transform: `translate(-50%, -50%) rotate(${Math.random() * 360}deg)`,
                                animation: `confetti-fall ${1 + Math.random() * 2}s ease-out ${Math.random() * 1}s infinite`,
                            }}
                        ></div>
                    ))}
                </div>

                {/* Large Blue Circle with Checkmark */}
                <div className="relative w-32 h-32 bg-blue-600 rounded-full flex items-center justify-center shadow-2xl">
                    <Check className="w-16 h-16 text-white" strokeWidth={3} />
                </div>
            </div>

            {/* Success Text */}
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Submitted Successfully
            </h2>
            
            {/* Description */}
            <p className="text-base text-gray-500 mb-10 px-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.
            </p>

            {/* Action Button */}
            <button
                onClick={onDone}
                className="w-full max-w-xs bg-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow hover:bg-blue-700 transition mt-4"
            >
                Done
            </button>

            {/* CSS for simple animation (inline style tag for single file) */}
            <style jsx>{`
                @keyframes confetti-fall {
                    0% {
                        opacity: 0;
                        transform: translate(0, 0) scale(1);
                    }
                    20% {
                        opacity: 1;
                    }
                    100% {
                        opacity: 0;
                        transform: translate(${Math.random() * 200 - 100}px, 200px) scale(0.5);
                    }
                }
                /* Use a global style tag for keyframes */
            `}</style>
        </div>
    );
};


// --- Wrapper / Router (Updated to handle 3 steps) ---
const NewMeterApplicationWrapper = ({ onBack = () => {}, setActiveScreen = () => {} }) => {
    const [step, setStep] = useState('details'); // 'details' | 'address' | 'documents'


    const handleNextStep = () => {
        if (step === 'details') setStep('address');
        else if (step === 'address') setStep('documents');
        else if (step === 'documents') setStep('success'); // Navigate to success
    };

    const handlePreviousStep = () => {
        if (step === 'documents') setStep('address');
        else if (step === 'address') setStep('details');
        else onBack(); // Go back from the entire wrapper
    };
    const handleFinalSubmission = () => {
        console.log('Application FINAL Submission Complete!');
        // Ideally redirect to a confirmation screen or track status view
        // setActiveScreen('confirmation'); 
        console.error('ALERT: Application Submitted Successfully!');
    };

     const handleDone = () => {
        console.log('User clicked Done on Success Screen. Resetting or Navigating Home.');
        // In a real app, this would navigate the user back to the home or dashboard screen.
        setStep('details'); // Resetting to the start for demo purposes
    };

    return (
        <div className="">
            {/* Conditional Rendering based on Step */}
            {step === 'details' && (
                <ApplicationDetailsView 
                    onNext={handleNextStep} 
                    onBack={handlePreviousStep} 
                />
            )}
            {step === 'address' && (
                <ApplicationAddressView 
                    onComplete={handleNextStep} 
                    onBack={handlePreviousStep} 
                />
            )}
              {step === 'documents' && (
                <ApplicationDocumentsView
                    onComplete={handleNextStep} // Now navigates to success view
                    onBack={handlePreviousStep}
                />
            )}
            {step === 'success' && (
                <ApplicationSuccessView
                    onDone={handleDone}
                />
            )}
        </div>
    );
};




export default NewMeterApplicationWrapper;